import { render, staticRenderFns } from "./CheckDeleteModal.vue?vue&type=template&id=2a99fe52&lang=pug"
import script from "./CheckDeleteModal.vue?vue&type=script&lang=ts"
export * from "./CheckDeleteModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports